/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicyFilter {
    getFixupPrototypeFunction() { return PolicyFilter.fixupPrototype; }

    static newInstance(model: Partial<PolicyFilter>): PolicyFilter {
        let obj = Object.assign(new PolicyFilter(), model);
        PolicyFilter.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicyFilter>): PolicyFilter {
        if (!model) return null;
        return PolicyFilter.newInstance(<PolicyFilter> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicyFilter) {
        if (!obj) return;

        models.PolicyFilter.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicyFilter): boolean {
        Object.setPrototypeOf(obj, PolicyFilter.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
    }

    /**
     * Tenant ID
     */
    tenant_id: string;

    /**
     * Filter by classification, engine_type, severity, status, scope, services, category
     */
    filters: models.QueryOperator;

    /**
     * Search by policy name or description
     */
    search: string;

}
